/**
 * TSCORP-388: HR login page — SSO via auth.tscorp.ai
 * MYB-371: Auth is now via Platform Token cookie (.tscorp.ai domain).
 *
 * Redirects to auth.tscorp.ai/login which handles Microsoft SSO and
 * sets a fresh tscorp_platform_token cookie on .tscorp.ai domain,
 * then redirects back to hr.tscorp.ai.
 */
import React, { useEffect } from 'react';
import { AUTH_URL } from '../lib/service-registry';

const AUTH_BASE = AUTH_URL;

let _redirectAttempted = false;

const LoginPage: React.FC = () => {
  useEffect(() => {
    if (_redirectAttempted) return;
    _redirectAttempted = true;

    const callbackUrl = encodeURIComponent(window.location.origin);
    window.location.href = `${AUTH_BASE}/login?callbackUrl=${callbackUrl}`;
  }, []);

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo-section">
          <div className="login-logo-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <h1 className="login-title">TSCORP HR Intelligence</h1>
          <p className="login-subtitle">Microsoft 로그인으로 이동 중...</p>
        </div>
        <div style={{ textAlign: 'center', padding: '16px 0' }}>
          <div
            style={{
              width: 32,
              height: 32,
              border: '2px solid #e8eaed',
              borderTopColor: '#1e8e3e',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
